/**
 * @namespace CsValueHelpers
 * @param value
 * @returns
 */
export function isValueDisabled(value) {
    return !value.isAllowed;
}
/**
 *
 * @param value
 * @returns
 */
export function isSuggestedValue(value) {
    return value.recommendationScore == null
        ? null
        : value.recommendationScore > 0
            ? true
            : value.recommendationScore < 0
                ? false
                : null;
}
/**
 * @namespace CsValueHelpers
 * @param value
 * @returns
 */
export function getSuggestedFlag(value) {
    return value.recommendationScore == null
        ? "*"
        : value.recommendationScore > 0
            ? "+"
            : value.recommendationScore < 0
                ? "-"
                : "*";
}
//# sourceMappingURL=CsValueHelpers.js.map